import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';


class SessionCountDown extends Component {


    constructor(props) {
        super(props);



        this.state = {
            timeRemaining: this._getTimeRemaining()
        };
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            this.setState({
                timeRemaining: this._getTimeRemaining()
            })
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

     _getTimeRemaining = () => {
        var d = new Date();
        var d2 = new Date(this.props.tokenValidUntil);
        var milSec = d2-d;
        var d3 = new Date(milSec);
        return {
            seconds:  (Math.floor(d3/1000))%60,
            minutes:  (Math.floor(d3/1000/60))%60,
            hours:  (Math.floor(d3/1000/60/60))%24,
        }
    }

    render(){

        return (
            <div className={'session-count_down-timer'}>
                <strong>
                    {'Session expires in: ' +
                    (moment(this.state.timeRemaining).isValid()? moment(this.state.timeRemaining).format("HH:mm:ss"):'')
                    }
                </strong>
            </div>
        )
    }

};

const mapStateToProps = (state) => {
    return {
        tokenValidUntil: state.user.loggedInUser.tokenValidUntil,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(SessionCountDown);